import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { MatDialog } from '@angular/material';
import { DropFileComponent } from '../drop-file/drop-file.component';
import { IFileInfo } from '../../../../directives/file-drop/interfaces/IFileInfo';
import { FileUploadService } from '../../../../directives/file-drop/file-upload.service';
import { ConditionalExpr } from '@angular/compiler';

@Component({
  selector: 'app-attach-file',
  templateUrl: './attach-file.component.html',
  styleUrls: ['./attach-file.component.css']
})
export class AttachFileComponent implements OnInit, OnChanges {
  fileInfo: IFileStoreItem = null;
  public loading = false;
  @ViewChild('preview', {static: false}) preview: ElementRef;
  @Input() container: string = null;
  @Input() partition: string = null;
  @Input() fileId: string = null;
  @Input() previewHeight: number = null;
  @Input() previewWidth: number = null;
  @Output() uploadedFile = new EventEmitter<IFileStoreItem>();

  constructor(
    private fileService: FileUploadService,
    public dialog: MatDialog,
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fileId']) {
      const oldfileId = changes['fileId'].previousValue;
      const fileId = changes['fileId'].currentValue;
      if (fileId && oldfileId !== fileId) {
        this.onLoad();
      }
    }
  }
  ngOnInit() {
      this.onLoad();
  }
  onPreviewLoad() {
    const elem = this.preview.nativeElement as HTMLImageElement;
    if (elem) {
      const w = elem.width;
      const h = elem.height;
      if (this.previewHeight) {
        const hproc = this.previewHeight * 100 / h;
        const cw = w * hproc / 100;
        elem.height = this.previewHeight;
        elem.width = cw;
      }
      if (this.previewWidth) {
        const wproc = this.previewWidth * 100 / w;
        const ch = h * wproc / 100;
        elem.height = ch;
        elem.width = this.previewWidth;
      }
    }
  }
  onLoad() {
    if (this.container && this.fileId) {
      this.onStartLoad();
      const file = <IFileInfo>{
        container: this.container,
        partition: this.partition,
        id: this.fileId
      };
      this.fileService.Get(file).subscribe((fileItem: IFileStoreItem) => {
        this.onEndtLoad();
        if (fileItem) {
          this.fileInfo = fileItem;
        }
      }, () => {
        this.onEndtLoad();
      });
    }
  }
  onAttach() {
    const dialogRef = this.dialog.open(DropFileComponent, {
      data: <IFileInfo>{
        container: this.container,
        partition: this.partition,
        id: this.fileId
      }
    });
    dialogRef.afterClosed().subscribe((file: IFileStoreItem) => {
      if (file) {
        this.fileInfo = file;
        this.uploadedFile.emit(file);
      }
    });
  }
  onDelete() {
    if (this.fileInfo && this.fileInfo.id) {
      this.onStartLoad();
      this.fileService.Delete(this.fileInfo).subscribe(() => {
        this.fileInfo = null;
        this.onEndtLoad();
        this.uploadedFile.emit(this.fileInfo);
      }, () => {
        this.onEndtLoad();
      });
    }
  }
  onRecreate(){
    if (this.fileInfo && this.fileInfo.id) {
      this.fileService.Recreate(this.fileInfo).subscribe(result =>{
        console.log('onRecreate', result);
      })
    }    
  }
  onStartLoad() {
    setTimeout(() => {
      this.loading = true;
    }, 0);
  }
  onEndtLoad() {
    setTimeout(() => {
      this.loading = false;
    }, 0);
  }
}
